<style lang="less" scoped>
    .h5-charge-card-list-container {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        background: #ffffff;
        .header-title-div {
            height: 32px;
            display: flex;
            margin-top: 16px;
            .header-left-img-div {
                width: 32px;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-left: 10px;
            }
            .header-title {
                flex: 1;
                font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #000000;
                line-height: 32px;
            }
        }
        .charge-card-list-div {
            margin-top: 16px;
            .charge-card-child-div {
                height: 173px;
                width: 100%;
                margin-top: -12px;
                background-image: url('../../assets/h5-img/charge-card1.png');
                background-size: 100% 100%;
                border-radius: 30px;
                display: flex;
                .card-logo-div {
                    margin-left: 36px;
                    margin-top: 24px;
                    width: 47px;
                    height: 47px;
                    border-radius: 50%;
                    background-color: #ffffff;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
                .right-card-info-div {
                    display: flex;
                    flex-direction: column;
                    flex: 1;
                    .card-title-div {
                        margin-top: 24px;
                        margin-right: 32px;
                        text-align: right;
                        height: 20px;
                        font-size: 14px;
                        font-family: PingFangSC-Semibold, PingFang SC;
                        font-weight: 600;
                        color: #FFFFFF;
                        line-height: 20px;
                    }
                    .card-contact-div {
                        height: 14px;
                        font-size: 10px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #FFFFFF;
                        line-height: 14px;
                        margin-right: 32px;
                        text-align: right;
                    }
                    .card-degree-div {
                        height: 17px;
                        font-size: 12px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #FFFFFF;
                        text-align: right;
                        margin-right: 32px;
                        line-height: 17px;
                        margin-bottom: 32px;
                    }
                    .card-degree-value-div {
                        font-size: 16px;
                        font-family: PingFangSC-Semibold, PingFang SC;
                        font-weight: 600;
                    }
                }
            }
        }
        .card-dt-info-line-flex-div {
            margin: 6px 20px;
            height: 40px;
            background: #F4F4FB;
            border-radius: 13px;
            display: flex;
            .cdilf-left-title {
                height: 40px;
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #000000;
                line-height: 40px;
                margin-left: 12px;
                flex: 1;
            }
            .cdilf-right-image{
                display: flex;
                justify-content: center;
                align-items: center;
                width: 40px;
            }
        }
    }
</style>

<template>
    <div class="h5-charge-card-list-container">
        <div class="header-title-div">
            <div class="header-left-img-div" @click="backToMain()">
                <img class="header-back-img" src="../../assets/h5-img/back.png" width="18" />
            </div>
            <div class="header-title">我的充电卡</div>
        </div>
        <div class="charge-card-list-div">
            <div class="charge-card-child-div">
                <div class="card-logo-div">
                    <img :src="curCardInfo.iconImg" width="29" height="30">
                </div>
                <div class="right-card-info-div">
                    <div class="card-title-div">{{curCardInfo.dealerName}}·充电卡</div>
                    <div class="card-contact-div">服务电话：{{curCardInfo.connectPhone}}</div>
                    <div class="flex-1"></div>
                    <div class="card-degree-div">
                        剩余度数:
                        <span class="card-degree-value-div">{{curCardInfo.cardElectricBalance}}</span> 度
                    </div>
                </div>
            </div>
        </div>
        <div class="card-dt-info-line-flex-div" @click="toDtPage('h5_rechargeRecord')">
            <div class="cdilf-left-title">变动明细</div>
            <div class="cdilf-right-image">
                <img src="../../assets/h5-img/arrow-right.png" width="7" height="11">
            </div>
        </div>

        <div class="card-dt-info-line-flex-div" @click="toDtPage('h5_consumptionRecord')">
            <div class="cdilf-left-title">消费明细</div>
            <div class="cdilf-right-image">
                <img src="../../assets/h5-img/arrow-right.png" width="7" height="11">
            </div>
        </div>

        <div class="card-dt-info-line-flex-div" @click="toDtPage('h5_rangeRecord')">
            <div class="cdilf-left-title">适用范围</div>
            <div class="cdilf-right-image">
                <img src="../../assets/h5-img/arrow-right.png" width="7" height="11">
            </div>
        </div>

        <div class="card-dt-info-line-flex-div" @click="toDtPage('h5_about')">
            <div class="cdilf-left-title">关于服务商</div>
            <div class="cdilf-right-image">
                <img src="../../assets/h5-img/arrow-right.png" width="7" height="11">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                curCardInfo:{},
            }
        },
        methods: {
            init() {},
            // 返回列表页
            backToMain(){
                this.$store.commit('setCardDetailBack','Y')
                this.$router.push({
                    name: 'h5_chargeCardList'
                })
            },
            // 跳转详情页
            toDtPage(routerName){
                this.$router.push({
                    name: routerName
                })
            },
        },
        mounted() {
            this.$store.commit('setCardDetailBack','N')
            this.curCardInfo = this.$store.state.curSelChargeCardInfo;
            this.init();
        }
    }
</script>